
import {createI18n} from 'vue-i18n/index';
// import App from "../App.vue";
// const app = createApp(App);
import ko from './ko'
import ja from './ja'
import en from './en'
import zh_CN from './zh-CN'
import zh_TW from './zh-TW'

const messages = {
    'zh-CN':{
        ...zh_CN
    },
    'ko': {
        ...ko
      },
      'ja': {
        ...ja
      },
      'en': {
        ...en
      },
      'zh-TW': {
        ...zh_TW
      }
}
const navLang = navigator.language || navigator.userLanguage;
// let localLang = "cn"; //本地开发语言包
let lang = navLang || "zh-TW"; //实际语言包
localStorage.setItem("lang", lang);

const i18n = new createI18n({
  locale: lang,
  fallbackLocale:'en',
  messages
  
})

export default i18n